module.exports = __webpack_public_path__ + "static/background4-37b8dee2ed398e9796b1e6816daa5680.jpg";